import { fetchWrapper } from 'app/_helpers/fetch-wrapper';

const WMSOutbondURL = process.env.REACT_APP_API_WMSOUTBOUND_URL;
const baseUrl = `${WMSOutbondURL}picking`;
export const PickService = {
    getAll,
    getById,
    create,
    GetPickingAssignByOrderId,
    GetAllItemsInMarshall,
    GetPickingByOrderId,
    GetPickforAssign,
    AssignPiker,
    GetPickforPickOverride,
    PickoverrideAction,
    update,
    delete: _delete
};

function getAll() {
    return fetchWrapper.get(baseUrl);
}

function getByIdOrderStatusId(id) {
    return fetchWrapper.get(`${baseUrl}/status-id?id=${id}`);
}
function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function GetPickingAssignByOrderId(id) {
    return fetchWrapper.get(`${baseUrl}/pick-assign?orderId=${id}`)
}

function GetAllItemsInMarshall() {
    return fetchWrapper.get(`${baseUrl}/marshal-area`)
}

function GetPickingByOrderId(id) {
    return fetchWrapper.get(`${baseUrl}/order-id?orderId=${id}`);
}
function GetPickforAssign(id) {
    return fetchWrapper.get(`${baseUrl}/pickup-for-assign?orderId=${id}`);
}
function GetPickforPickOverride(id) {

    return fetchWrapper.get(`${baseUrl}/pick-override?orderId=${id}`);
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}
function AssignPiker(params) {

    return fetchWrapper.post(`${baseUrl}/assign-pick-up`, params);
}
function PickoverrideAction(params) {

    return fetchWrapper.post(`${baseUrl}/pick-override-action`, params);
}



function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}